module.exports = __webpack_public_path__ + "img/hxkj-jjfa-4.2a5a0f96.svg";